import { render, staticRenderFns } from "./NewMaterial.vue?vue&type=template&id=876263da"
import script from "./NewMaterial.vue?vue&type=script&lang=js"
export * from "./NewMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports